export default [
  {
    title: 'Construction & Tradesmen',
    description:
      'Plumbers, HVAC, Electricians, Roofers, Carpenters, Welders, Painters, General Contractors, etc.',
    slug: 'tradesmen'
  },
  {
    title: 'Outdoor Services',
    description:
      'Landscaping, Lawn Care, Property Maintenance, Irrigation, Hardscaping, Snow Removal, etc.',
    slug: 'outdoor-services'
  },
  {
    title: 'Real Estate',
    description:
      'Short-term Rentals, Long-term Rentals, Residential & Commercial Properties, Real Estate Agents, Flipping Properties, etc.',
    slug: 'real-estate'
  },
  {
    title: 'Professional Services',
    description:
      'Architects, Consultants, Cosmetologists, Therapists, Software Developers, Photographers, Interior Designers, etc.',
    slug: 'professional-services'
  },
  {
    title: 'Retail',
    description: 'Retail shops and Online Boutiques, etc.',
    slug: 'retail'
  },
  {
    title: 'Auto Industry',
    description:
      'Dealerships, Auto Financing & Flooring, Repair shops, Detail and Washing, Tire & Brake shops, Mobile repair, etc.',
    slug: 'auto'
  },
  {
    title: 'Independent Contractors',
    description: 'All 1099 contractors.',
    slug: 'independent-contractors'
  },
  {
    title: 'Small Business',
    description: 'All side businesses.',
    slug: 'small-businesses'
  },
  {
    title: 'Manufacturing',
    description: '3D Printing, Nutraceuticals, Small Equipment, Printing & Shipping, etc.',
    slug: 'manufacturing'
  }
];
